class PrintController {
    /*@ngInject*/
    constructor($translate) {
        this.$translate = $translate;
        this.model = {
            item: null
        };
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.item = window.opener.w.printData;
            this.model.companyPhoneNumber = this.formatPhoneNumber(this.model.item.envConfigResults[0].assets.companyPhoneNumber);
            this.printShipment();
        }
    }

    printShipment() {
        setTimeout(() => {
            window.print();
        }, 1500)
    }

    formatPhoneNumber(input) {
        if (!input) return '';
        const digits = input.replace(/\D/g, '');

        if (digits.length === 0) return '';
        if (digits.length < 4) return `(${digits}`;
        if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        if (digits.length <= 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;

        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)} ${digits.slice(10)}`;
    }

    formatAmount = (val) => {
        const num = Number(val || 0);
        return num.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };
}
export default PrintController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/items/print/items.controller.js